import axios from 'axios'

// baseURL sudah termasuk /api/v1. Simpan daftar app yang di-off (masuk grup "Aplikasi Lainnya").
// Bersifat replace: kirim daftar lengkap kondisi terkini; array kosong = semua kembali ke top-level.
export const putSidebarApps = (grouped_apps) => {
  return axios.put('/finance/sidebarApps', { grouped_apps })
}
